<div class="container">
    <div class="display-4 mt-3">
        설치확인
    </div>
    <div class="input-group mt-3">
        <input type="text" class="form-control" placeholder="01212345678"
            maxlength="11"
            [(ngModel)]="searchKey">
        <button type="button" class="btn btn-primary"
            (click)="clickSearch()">
            확인
        </button>
    </div>
    <hr class="mt-5">
    <div class="h5">
        마지막 수신 정보
    </div>
    <div class="overflow-auto" style="max-height:60vh;">
        <ng-container *ngFor="let item of listItem;let idx = index;">
            <table class="table table-sm table-bordered text-nowrap mb-5">
                <tbody>
                    <tr>
                        <th class="col-auto">
                            차량번호
                        </th>
                        <td>
                            {{item.dtgCarNo}}
                        </td>
                    </tr>
                    <tr>
                        <th class="col-auto">
                            회선번호
                        </th>
                        <td>
                            {{item.dtgUnitId}}
                        </td>
                    </tr>
                    <tr>
                        <th class="col-auto">
                            차대번호
                        </th>
                        <td>
                            {{item.dtgVin}}
                        </td>
                    </tr>
                    <tr>
                        <th class="col-auto">
                            차량종류
                        </th>
                        <td>
                            {{item.dtgCarTypeNm}}
                        </td>
                    </tr>
                    <tr>
                        <th class="col-auto">
                            사업자번호
                        </th>
                        <td>
                            {{item.dtgEid}}
                        </td>
                    </tr>
                    <tr>
                        <th class="col-auto">
                            수신일시
                        </th>
                        <td>
                            {{item.dtgRegDt}}
                        </td>
                    </tr>
                    <tr>
                        <th class="col-auto">
                            위치
                        </th>
                        <td>
                            {{item.dtgGpsAddr}}
                        </td>
                    </tr>
                    <tr>
                        <th class="col-auto">
                            keyon
                        </th>
                        <td>
                            <span>
                                {{item.dtgKeyonYn}}
                            </span>
                            <span class="ml-2">
                                (0:off / 1:on)
                            </span>
                        </td>
                    </tr>
                    <tr>
                        <th class="col-auto">
                            rssi
                        </th>
                        <td>
                            {{item.dtgRssi}}
                        </td>
                    </tr>
                    <tr>
                        <th class="col-auto">
                            rpm
                        </th>
                        <td>
                            {{item.dtgRpm}}
                        </td>
                    </tr>
                    <tr>
                        <th class="col-auto">
                            speed
                        </th>
                        <td>
                            {{item.dtgSpeed}}
                        </td>
                    </tr>
                    <tr>
                        <th class="col-auto">
                            temper1
                        </th>
                        <td>
                            {{item.dtgTemper1}}
                        </td>
                    </tr>
                    <tr>
                        <th class="col-auto">
                            temper2
                        </th>
                        <td>
                            {{item.dtgTemper2}}
                        </td>
                    </tr>
                </tbody>
            </table>
        </ng-container>
        <ng-container *ngIf="!listItem">
            <div class="h5 text-center bg-light">
                미확인
            </div>
        </ng-container>
    </div>
</div>
